import React from 'react'
import '../styles/Project.scss'
import { Breakpoint } from 'react-socks';
import CodeIcon from '@material-ui/icons/Code';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';

// on hover display name
// click pop up box w desc and link
// maybe demo

function Project({source, url, demo}) {
  return (
    <div className='project'>     
      <Breakpoint large up>
        <div className='project-container'>
          <img className='project-image' src={source}/>
          <div className='project-hidden'>
            <a className='project-link' href={url} target='_blank'><CodeIcon fontSize='large'/></a>
            <a className='project-link' href={demo} target='_blank'><VideoLabelIcon fontSize='large'/></a>
          </div>
        </div>
      </Breakpoint>
      <Breakpoint medium down>
        <div className='project-container'>
          <img className='project-image' src={source}/>
          <div className='project-hidden'>
            <a className='project-link' href={url} target='_blank'><CodeIcon fontSize='medium'/></a>
            <a className='project-link' href={demo} target='_blank'><VideoLabelIcon fontSize='medium'/></a>
          </div>
        </div>
      </Breakpoint>
    </div>
  )
}

export default Project
